<script setup lang="ts">
import { useRouter } from 'vue-router';
import pageNotFoundImg from '@/assets/Images/404.jpg'

const router = useRouter();

function navigateHome() {
    router.push("/");
}
</script>
<template>
  <div class="block-content">
    <div class="">
      <div class="surface-section px-4 py-8 md:px-6 lg:px-8">
        <div class="flex flex-column lg:flex-row justify-content-center align-items-center gap-7">

          <div class="text-center lg:text-right">
            <div class="mt-6 mb-3 font-bold text-6xl text-900">Are you lost?</div>
            <p class="text-700 text-3xl mt-0 mb-6">Sorry, we couldn't find the page.</p>
            
            <button
              class="p-button p-component p-button-outlined"
              type="button"
              aria-label="Go back to home page"
              @click="navigateHome"
            >
              <span class="p-button-label">Go back to home page</span>
              <span class="p-ink" role="presentation" />
            </button>
          </div>

          <div>
            <img
              :src="pageNotFoundImg"
              alt="Image"
              class="w-full md:w-28rem"
            />
          </div>

          
        </div>
      </div>
    </div>
  </div>
</template>
